export default {
  title: 'Menu importeren',
  master_title: 'Merkmodus - Menu importeren',
  buttons: {
    import: 'Importeren',
  },
  toasts: {
    import: {
      pending:
        '⏳Het importeren kan soms traag zijn, we doen dit op de achtergrond. Controleer het restaurantmenu over een paar minuten.',
    },
  },
};
